import styled from 'styled-components'

const WrapItem = styled.div`
    display: grid;
    grid-template-columns: minmax(120px, 150px) minmax(80px, 110px) minmax(180px, 1fr) minmax(113px, 1fr) minmax(280px, 1fr) minmax(155px, 185px) 100px ; 
    grid-gap: 10px;    
    align-items: center;
    height: 60px;
    /* min-width: 1120px; */
    background: #FFFFFF;
    margin-bottom: 8px;
    box-shadow: inset 0px -0.55px 0px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 13.5px;
    line-height: 18px;
    color: #313131;
    padding: 1px 12px 1px 16px;
    box-sizing: border-box;
    &:hover {
        cursor: pointer;
        border: 1px solid #33ADFF;
        padding: 0 11px 0 15px;
    }
    div{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
    }   
    .wrap-status{
        display: flex;
        align-items: center;
        .document-id{
            padding-left: 8px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
        }
    }
    .face-print{
        height: 36px;
        .face{
            width: 36px;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
        }
    }
    .wrap-warning{
        display: flex;
        align-items: center;
        .warning{
            display: flex;
            align-items: center;
            font-family: 'Open Sans';
            font-style: normal;
            font-weight: 600;
            font-size: 13.5px;
            line-height: 18px;
            color: #F45C5C;
            .ic-warning{
                padding-right: 4px;
            }
        }
    }
    .wrap-time{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #33ADFF;
        font-weight: 600;
        letter-spacing: -0.01em;
        .icon-arrow{
            width: 14px;
            height: 14px;          
        }
        &.red{
            color: #F45C5C;
        }
    }
`
export { WrapItem }